import { usd, type ExecutiveTransaction } from "../../data/executiveOverview";

const terms = [
  { key: "Immediate", label: "IMMEDIATE" },
  { key: "Net 15", label: "NET 15" },
  { key: "Net 30", label: "NET 30" },
  { key: "Net 45", label: "NET 45" },
  { key: "Net 60", label: "NET 60" },
] as const;

export function PaymentTermsImagePanel({ rows }: { rows: ExecutiveTransaction[] }) {
  const vendorTotals = new Map<string, Record<string, number>>();
  for (const row of rows) {
    const vendor = vendorTotals.get(row.Parent_Supplier) || {};
    vendor[row.Payment_Term] = (vendor[row.Payment_Term] || 0) + row.Spend_Amount_USD;
    vendorTotals.set(row.Parent_Supplier, vendor);
  }
  const vendorData = Array.from(vendorTotals.entries())
    .map(([vendor, byTerm]) => ({
      vendor,
      byTerm,
      total: Object.values(byTerm).reduce((sum, value) => sum + value, 0),
    }))
    .sort((first, second) => second.total - first.total)
    .slice(0, 50);

  return (
    <div className="spend-table-card">
      <div className="spend-table-title">
        SPEND BY PAYMENT METHOD (TOP 50 VENDORS)
      </div>
      <div className="spend-table-header">
        <div className="spend-col-vendor">VENDOR</div>
        {terms.map((term) => <div key={term.key}>{term.label}</div>)}
        <div className="spend-col-total">TOTAL</div>
      </div>
      {vendorData.map((row) => (
        <div key={row.vendor} className="spend-table-row">

          <div className="spend-col-vendor">{row.vendor}</div>
          {terms.map((term) => (
            <div key={term.key}>{row.byTerm[term.key] ? usd(row.byTerm[term.key]) : "-"}</div>
          ))}
          <div className="spend-col-total">{usd(row.total)}</div>

        </div>
      ))}
      {!vendorData.length && <div style={{ padding: "12px 0", color: "#888" }}>No spend matches the selected filters.</div>}

    </div>
  );
}
